import { Button, Container, Form, Modal, Pagination, Table } from "react-bootstrap";
import { useEffect, useRef, useState } from "react";
import FilterSearch from "../../../../SharedComponents/filterSearch/filterSearch";
import Select from "react-select";
import { addProductClientWisePrice, deleteProductClientWisePrice, getAllClients, getProductClientWisePrice, getProductList } from "../../../../Services/adminService";
import { useSelector } from "react-redux";
import { errorToast, successToast } from "../../../../Services/toastService";

const ClientWisePrice = () => {
  const [tableData, setTableData] = useState([]);
  const [count, setCount] = useState(0);
  const [searchObj, setSearchObj] = useState([]);
  const [orderBy, setOrderBy] = useState({ createdAt: "desc" });
  const filterSearchRef1 = useRef(null);
  const filterSearchRef2 = useRef(null);
  const filterSearchRef3 = useRef(null);
  const token = useSelector((state) => state.token);
  const [addClientWisePriceModal, setAddClientWisePriceModal] = useState(false);
  const [limit, setLimit] = useState(10);
  // const [productList, setProductList] = useState([]);
  const [options, setOptions] = useState([]);
  const [reqObj, setReqObj] = useState({
    productId: "",
    clientId: "",
    price: "",
  });
  const [clientList, setClientList] = useState([]);

  useEffect(() => {
    getProductClientWisePrice(token, searchObj, orderBy, 0, limit).then((res) => {
      setTableData(res.data.data);
      setCount(res.data.count);
    });
  }, [searchObj, orderBy, token, limit]);

  useEffect(() => {
    getProductData();
    userData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let items = [];
  let paginationNum = [10, 25, 50];
  paginationNum.forEach((number) => {
    items.push(
      <Pagination.Item
        key={number}
        active={number === limit}
        onClick={() => setLimit(number)}
      >
        {number}
      </Pagination.Item>
    );
  });

  const filterSearch = async (obj, isSelected) => {
    let current = searchObj;
    current = current.filter((item) => item.column !== obj.column);
    if (isSelected) {
      setSearchObj(current);
    } else {
      current.push(obj);
      setSearchObj(current);
    }
  };

  const handleLoadMore = async () => {
    try {
        getProductClientWisePrice(token, searchObj, orderBy, tableData.length, limit).then((res) => {
          setTableData([...tableData, ...res.data.data]);
          setCount(res.data.count);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const getProductData = async () => {
    try {
      const res = await getProductList(token);
      if (res.status === 200) {
        // setProductList(res.data);
        let data = [];
        res.data.map((item) => {
          return data.push({
            value: item.id,
            label: item.name,
            saleUOM: item.saleUOM,
          });
        });
        setOptions(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const userData = async () => {
    try {
      const res = await getAllClients(token);
      setClientList(res.data.clients);
    } catch (err) {
      return errorToast("Something went wrong");
    }
  };

  const handleAddBtn = async (e) => {
    e.preventDefault();
    try {
      const res = await addProductClientWisePrice(token, reqObj);
      if (res.status === 200) {
        setAddClientWisePriceModal(false);
        setReqObj({
          productId: "",
          clientId: "",
          price: "",
        });
        successToast("Client Wise Price added successfully");
        getProductClientWisePrice(token, searchObj, orderBy, 0, limit).then((res) => {
          setTableData(res.data.data);
          setCount(res.data.count);
        });
      }
    } catch (err) {
      console.log(err);
      errorToast(err.response.data.message || "Something went wrong");
    }
  }

  return (
    <Container>
      <h4 className="my-4">Client Wise Price</h4>
      <Button onClick={() => setAddClientWisePriceModal(true)}>+ Add Client Wise Price</Button>

      {tableData && !!tableData.length ? (
        <Table bordered responsive className="mt-4">
          <thead>
            <tr>
              <FilterSearch
                name="Product ID"
                table="productSKU"
                column="productId"
                type="contains"
                search={filterSearch}
                ref={filterSearchRef1}
                orderBy={orderBy}
                setOrderBy={setOrderBy}
              />
              <FilterSearch
                name="Product Name"
                table="productSKU"
                column="productName"
                type="contains"
                search={filterSearch}
                ref={filterSearchRef2}
                orderBy={orderBy}
                setOrderBy={setOrderBy}
              />
              <FilterSearch
                name="Client ID"
                table="productSKU"
                column="clientId"
                type="contains"
                search={filterSearch}
                ref={filterSearchRef2}
                orderBy={orderBy}
                setOrderBy={setOrderBy}
              />
              <FilterSearch
                name="Price INR"
                table="productSKU"
                column="price"
                search={filterSearch}
                ref={filterSearchRef3}
                orderBy={orderBy}
                setOrderBy={setOrderBy}
              />
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {tableData.map((item, index) => (
              <tr key={index}>
                <td>{item.productId}</td>
                <td>{item.productName}</td>
                <td>{item.clientId}</td>
                <td>{item.price}</td>
                <td>
                    <Button variant="danger" onClick={() => {
                        if(window.confirm("Are you sure you want to delete this client wise price?")) {
                            deleteProductClientWisePrice(token, item.id).then((res) => {
                                if(res.status === 200) {
                                    successToast("Client wise price deleted successfully");
                                    getProductClientWisePrice(token, searchObj, orderBy, 0, limit).then((res) => {
                                        setTableData(res.data.data);
                                        setCount(res.data.count);
                                    });
                                }
                            });
                        }
                    }}>Delete</Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <div className="text-center">No Data Available</div>
      )}
      {tableData && !!tableData.length && tableData.length > 0 && (
        <div className="d-flex justify-content-between align-items-center">
          <div>
            {tableData.length} / {count}
          </div>
          <div>
            <Pagination>{items}</Pagination>
          </div>
        </div>
      )}
      <div className="text-center my-2">
        {tableData && count > tableData.length ? (
          <Button
            variant="dark"
            onClick={() => {
              handleLoadMore();
            }}
          >
            Load more
          </Button>
        ) : null}
      </div>

      <Modal show={addClientWisePriceModal} onHide={() => setAddClientWisePriceModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Create Client Wise Price</Modal.Title>
        </Modal.Header>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            handleAddBtn(e);
          }}
        >
          <Modal.Body>
            <Form.Group className="mb-3" required>
              <Form.Label>Select Product</Form.Label>
              <Select
                options={options}
                value={
                  options.find((opt) => opt.value === reqObj.productId) || null
                }
                onChange={(e) => {
                  setReqObj({
                    ...reqObj,
                    productId: e.value,
                  });
                }}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3" required>
              <Form.Label>Select Client</Form.Label>
              <Form.Select
                value={reqObj.clientId}
                onChange={(e) => {
                  setReqObj({ ...reqObj, clientId: e.target.value });
                }}
                required
              >
                <option value="">Select Client</option>
                {clientList.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.name} | {item.id}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3" required>
              <Form.Label>Price</Form.Label>
              <Form.Control type="number" value={reqObj.price} onChange={(e) => setReqObj({ ...reqObj, price: e.target.value })} required />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setAddClientWisePriceModal(false)}>
              Close
            </Button>
            <Button variant="primary" type="submit">
              Create
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </Container>
  );
};

export default ClientWisePrice;
